"use client";

import { useAppDispatch } from "@/store/hooks";
import { AddCartData, setCartData } from "@/store/slices/AddtoCartSlice";
import {
  mutationStart,
  mutationSuccess,
  mutationError,
} from "@/store/slices/cartMutationSlice";
import { useEffect } from "react";

export const CartInitializer = ({
  getCartData,
}: {
  getCartData: AddCartData;
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (getCartData) {
      dispatch(setCartData(getCartData));
    }
  }, [dispatch, getCartData]);

  return null;
};
